
(function(){
  'use strict';
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn,{once:true});}
  function noPersonalization(t){return /(without\s+(name|text|personal|photo|picture|image|logo)|no\s+(name|text|personal|photo|picture|image|logo)|plain(\s*\(without text\))?|not\s+personal)/i.test(t||'');}
  function namePersonalization(t){return /(with\s+(one\s+)?name|with\s+text|name\s+or\s+initials?|initials?|\bname\b|\btext\b|personaliz|personalis|engrave)/i.test(t||'')&&!noPersonalization(t);}
  function photoPersonalization(t){return /(with\s+(photo|picture|image|logo)|\bphoto\b|\bpicture\b|\bimage\b|\blogo\b|upload)/i.test(t||'')&&!noPersonalization(t);}
  function selectedText(form){
    var v=[];
    form.querySelectorAll('.swatch input[type="radio"]:checked').forEach(function(x){v.push(x.value||'');});
    form.querySelectorAll('.single-option-selector').forEach(function(x){if(x.value)v.push(x.value);});
    var s=form.querySelector('#productSelect'); if(s&&s.options[s.selectedIndex])v.push(s.options[s.selectedIndex].text||'');
    return v.join(' | ').toLowerCase();
  }
  function setField(field,show,req){
    if(!field)return;
    field.hidden=!show;
    field.querySelectorAll('input,textarea,select').forEach(function(i){
      i.disabled=!show;
      if(show&&req)i.setAttribute('required','required');else i.removeAttribute('required');
    });
  }
  function mountPersonalization(){
    var stage=document.getElementById('bb-personalization-staging'), form=document.querySelector('#AddToCartForm');
    if(stage&&form){
      var root=stage.querySelector('.bb-personalization');
      if(root){
        var qty=form.querySelector('.product-single__quantity'), btn=form.querySelector('#AddToCart');
        if(qty)form.insertBefore(root,qty); else if(btn)form.insertBefore(root,btn); else form.appendChild(root);
      }
      stage.remove();
    }
    document.querySelectorAll('.bb-personalization').forEach(initPersonalization);
  }
  function initPersonalization(root){
    var form=root.closest('form'); if(!form)return;
    var nf=root.querySelector('[data-personalization-field="name"]'), pf=root.querySelector('[data-personalization-field="photo"]');
    var ni=nf&&nf.querySelector('input[type="text"]'), pi=pf&&pf.querySelector('input[type="file"]');
    var has=root.dataset.hasPersonalizeOption==='true', nEnabled=root.dataset.nameEnabled==='true', pEnabled=root.dataset.photoEnabled==='true';
    function sync(){
      var t=selectedText(form), plain=noPersonalization(t), n=namePersonalization(t), p=photoPersonalization(t);
      var showN=nEnabled&&!plain&&(!has||n);
      var showP=pEnabled&&!plain&&(!has||p);
      setField(nf,showN,true);
      setField(pf,showP,true);
      root.classList.toggle('is-personalizing',showN||showP);
      root.classList.toggle('is-plain',!showN&&!showP);
    }
    form.addEventListener('change',function(e){
      if(e.target.matches('select,input[type="radio"]'))setTimeout(sync,10);
    });
    if(ni){
      var c=root.querySelector('.bb-char-count span');
      ni.addEventListener('input',function(){if(c)c.textContent=String(ni.value.length);});
    }
    if(pi){
      var pv=root.querySelector('.bb-photo-preview'), img=pv&&pv.querySelector('img'), rm=pv&&pv.querySelector('.bb-photo-preview__remove'), url=null;
      pi.addEventListener('change',function(){
        var f=pi.files&&pi.files[0];if(!pv||!img)return;
        if(!f){pv.hidden=true;return;}
        if(url)URL.revokeObjectURL(url);url=URL.createObjectURL(f);img.src=url;pv.hidden=false;
      });
      if(rm)rm.addEventListener('click',function(){
        pi.value='';if(url)URL.revokeObjectURL(url);url=null;pv.hidden=true;if(img)img.removeAttribute('src');
      });
    }
    setTimeout(sync,30);
  }
  function polishVariantUI(){
    var form=document.querySelector('#AddToCartForm');if(!form)return;
    var wrappers=[].slice.call(form.querySelectorAll('.selector-wrapper'));
    wrappers.forEach(function(w,i){
      w.classList.add('bb-option-block');
      var label=w.querySelector('label'), select=w.querySelector('select');
      if(label){
        var txt=(label.textContent||'').trim();
        if(/^personaliz/i.test(txt))label.textContent='Personalization';
        if(/^colors$/i.test(txt))label.textContent='Color';
      }
      if(select&&select.options.length===1)w.classList.add('bb-option-single');
      var sw=form.querySelector('.swatch[data-option-index="'+i+'"]');
      if(sw&&sw.querySelector('input[type="radio"]')){
        w.classList.add('bb-option-shadowed-by-swatch');
        sw.classList.add('bb-premium-swatch');
      }
    });
    form.querySelectorAll('.swatch .header').forEach(function(h){
      var t=(h.textContent||'').trim();
      if(/^personaliz/i.test(t))h.textContent='Personalization';
      if(/^colors$/i.test(t))h.textContent='Color';
    });
  }
  function stickyATC(){
    if(!document.body.classList.contains('template-product'))return;
    var form=document.querySelector('#AddToCartForm'), btn=document.querySelector('#AddToCart'), price=document.querySelector('#ProductPrice');
    if(!form||!btn)return;
    var bar=document.createElement('div');bar.className='bb-mobile-atc';bar.innerHTML='<div class="bb-mobile-atc__price"></div><button type="button" class="bb-mobile-atc__button"></button>';
    var bp=bar.querySelector('.bb-mobile-atc__price'), bb=bar.querySelector('.bb-mobile-atc__button');
    function sync(){bp.textContent=price?price.textContent.trim():'';bb.textContent=btn.textContent.trim()||'Add to cart';bb.disabled=btn.disabled;}
    sync();document.body.appendChild(bar);
    bb.addEventListener('click',function(){if(form.reportValidity&&!form.reportValidity()){var bad=form.querySelector(':invalid');if(bad)bad.focus();return;}btn.click();});
    new MutationObserver(sync).observe(btn,{childList:true,subtree:true,attributes:true});
    if(price)new MutationObserver(sync).observe(price,{childList:true,subtree:true,characterData:true});
    if('IntersectionObserver'in window){new IntersectionObserver(function(es){es.forEach(function(e){bar.classList.toggle('is-visible',!e.isIntersecting);});},{threshold:.15}).observe(btn);}else bar.classList.add('is-visible');
  }
  function polishHeader(){
    var h=document.querySelector('.site-header');if(!h)return;
    function u(){h.classList.toggle('bb-is-scrolled',window.pageYOffset>18);}u();window.addEventListener('scroll',u,{passive:true});
  }
  function imageHints(){
    var skip='.site-header img,.bb-home-hero img,.product-photo-container img';
    document.querySelectorAll('img').forEach(function(img){
      if(!img.hasAttribute('decoding'))img.setAttribute('decoding','async');
      if(!img.matches(skip)&&!img.hasAttribute('loading'))img.setAttribute('loading','lazy');
    });
  }
  function premiumSearch(){
    var input=document.getElementById('BBHeaderSearch');
    if(!input)return;
    document.addEventListener('keydown',function(e){
      var tag=(document.activeElement&&document.activeElement.tagName||'').toLowerCase();
      if(e.key==='/'&&!e.metaKey&&!e.ctrlKey&&!e.altKey&&tag!=='input'&&tag!=='textarea'&&tag!=='select'){
        e.preventDefault();input.focus();input.select();
      }
    });
  }
  ready(function(){
    document.documentElement.classList.add('bb-premium-ready');
    setTimeout(polishVariantUI,20);
    mountPersonalization();
    stickyATC();
    polishHeader();
    imageHints();premiumSearch();});})();